import { memo, useEffect } from 'react';

import { Page, Space } from 'components';
import { AgreementsMessage } from 'features/agreements';
import { HeadersCarousel } from 'features/headers';
import { ProductsContinuation, ProductsHighlightedList, ProductsMyList } from 'features/products';
import { ReportsList } from 'features/reports';
import { ExamsList } from 'features/exams';
import { ProgramsList } from 'features/programs';
import { useSchool } from 'features/school';
import { useMenu } from 'features/menu';
import { createUrl } from 'app/utils';

const Dashboard = () => {
  const { schoolUuid } = useSchool();
  const { setBackPathname, clearBackPathname } = useMenu();

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';

  let showPrograms = true;

  if (isBenndorf) {
    showPrograms = false;
  }

  useEffect(() => {
    clearBackPathname();

    return () => {
      setBackPathname(createUrl('dashboard'));
    };
  }, []);

  return (
    <Page>
      <AgreementsMessage />

      <HeadersCarousel />

      <ProductsContinuation />

      {showPrograms && (
        <>
          <ProgramsList type="highlighted" />
          <ProgramsList type="my" />
        </>
      )}

      <ProductsHighlightedList />

      <ProductsMyList />

      <Space height={{ m: 30, t: 60, d: 90 }} />

      <ReportsList local="dashboard" />

      <ExamsList local="dashboard" />
    </Page>
  );
};

export default memo(Dashboard);
